import React from 'react';
import { Select } from '@ann/web-components';
import { LLM_MODELS } from '../../../constants/playgroundConstants';

const ModelSection = ({ model, onModelChange }) => {
  return (
    <Select
      label="LLM Model"
      value={model}
      onChange={onModelChange}
      onSelectionChange={onModelChange}
      placeholder="Select LLM Model"
      size="small"
      width="100%"
    >
      <Select.Menu>
        {LLM_MODELS.map((provider) => (
          <Select.Group
            key={provider.value}
            title={provider.label}
            nItems={provider.models?.length || 0}
          >
            {provider.models.map((m) => (
              <Select.Item key={m.value} value={m.value} label={m.label}>
                {m.label}
              </Select.Item>
            ))}
          </Select.Group>
        ))}
      </Select.Menu>
    </Select>
  );
};

export default ModelSection;

